import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  DynamicPricingService,
  PREVIEW_DYNAMIC_PRICING_QUERY_PARAM,
  PropertyPricingService,
} from '@app/features/pricing-and-availability';
import { StepTriggerComponent } from '@app/features/pricing-and-availability/components/step-trigger/step-trigger.component';
import { PricesAndFees } from '@app/shared/models/tax';
import { CurrencyCodePipe } from '@app/shared/pipes/currency-code/currency-code.pipe';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { UiModule } from '@app/ui/ui.module';
import { Router } from '@angular/router';
import { DYNAMIC_PRICING_ACTIVATE_PERMISSIONS } from '@app/shared/interfaces/lib/dynamic-pricing.interface';
@Component({
  standalone: true,
  selector: 'sbnb-property-base-price',
  templateUrl: './property-base-price.component.html',
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, UiModule, CurrencyCodePipe, StepTriggerComponent],
})
export class PropertyBasePriceComponent implements OnInit {
  @Input() currency;
  @Input() dynamicPricingEnabled = false;
  @Input() showDynamicPricingCTA = false;

  public basePrice = PricesAndFees.basePrice;
  public priceSaveState$ = this.propertyDetailService.priceSaveState$;
  public pricingFeeDiscountData$ = this.propertyDetailService.pricingFeeDiscountData$;

  public basePriceSubject = new Subject<{ key: string; data: any }>();
  public dynamicPricingActivatePermissions$ = this.dynamicPricingService.dynamicPricingActivatePermissions$;
  public DYNAMIC_PRICING_ACTIVATE_PERMISSIONS = DYNAMIC_PRICING_ACTIVATE_PERMISSIONS;
  constructor(
    private readonly propertyDetailService: PropertyPricingService,
    private readonly router: Router,
    private readonly dynamicPricingService: DynamicPricingService
  ) {}

  ngOnInit(): void {
    this.basePriceSubject.pipe(debounceTime(300)).subscribe(({ key, data }) => {
      this.propertyDetailService.savePriceChanges({ key, data });
    });
  }

  savePriceChange(key: string, data: any) {
    this.basePriceSubject.next({ key, data });
  }

  public get basePriceDescription() {
    return 'Editing your Airbnb base price will update all days that do not have a price set manually or by a dynamic pricing integration. As new calendar dates open up, they take your base price.';
  }

  public dynamicPricingCTAClicked() {
    this.router.navigate([`/calendar/property/${this.propertyDetailService.propertyId}`], {
      queryParams: { source: 'p', [PREVIEW_DYNAMIC_PRICING_QUERY_PARAM]: 'true' },
    });
  }
}
